<template>
    <div
        id="anchor-description"
        class="container-top">
        <div class="container-top__left">
            <h2>{{ $t('topInfos.factsheet.title') }}</h2>
            <div>
                <h3>{{ $t('topInfos.factsheet.developer.title') }}</h3>
                <p>{{ $t('topInfos.factsheet.developer.name') }}</p>
            </div>
            <div>
                <h3>{{ $t('topInfos.factsheet.founding.title') }}</h3>
                <p>{{ $t('topInfos.factsheet.founding.date') }}</p>
            </div>
            <div>
                <h3>{{ $t('topInfos.factsheet.game.title') }}</h3>
                <a
                    href="https://sandbox.game"
                    target="_blank">
                    {{ $t('topInfos.factsheet.game.url') }}
                </a>
            </div>
            <div>
                <h3>{{ $t('topInfos.factsheet.press.title') }}</h3>
                <a href="mailto:contact@sandbox.game">
                    {{ $t('topInfos.factsheet.press.mail') }}
                </a>
            </div>
            <div>
                <h3>{{ $t('topInfos.factsheet.social.title') }}</h3>
                <a
                    href="https://twitter.com/TheSandboxGame"
                    target="_blank">
                    {{ $t('topInfos.factsheet.social.twitter') }}
                </a>
                <a
                    href="https://www.facebook.com/TheSandboxGame/"
                    target="_blank">
                    {{ $t('topInfos.factsheet.social.facebook') }}
                </a>
                <a
                    href="https://www.youtube.com/channel/UCzv1t7voB-bxMmXLysT4h0w"
                    target="_blank">
                    {{ $t('topInfos.factsheet.social.youtube') }}
                </a>
                <a
                    href="https://discord.gg/thesandboxgame"
                    target="_blank">
                    {{ $t('topInfos.factsheet.social.discord') }}
                </a>
                <a
                    href="https://www.twitch.tv/thesandboxgame"
                    target="_blank">
                    {{ $t('topInfos.factsheet.social.twitch') }}
                </a>
                <a
                    href="https://www.instagram.com/thesandboxgame/"
                    target="_blank">
                    {{ $t('topInfos.factsheet.social.instagram') }}
                </a>
                <a
                    href="https://t.me/sandboxgame"
                    target="_blank">
                    {{ $t('topInfos.factsheet.social.telegram') }}
                </a>
                <a
                    href="https://medium.com/sandbox-game"
                    target="_blank">
                    {{ $t('topInfos.factsheet.social.medium') }}
                </a>
                <a
                    href="https://www.reddit.com/r/TheSandboxGaming/"
                    target="_blank">
                    {{ $t('topInfos.factsheet.social.reddit') }}
                </a>
            </div>
        </div>
        <div class="container-top__right">
            <div
                v-for="(elmt, index) in $t('topInfos.description')"
                :key="index"
                class="container-top__paragraph">
                <h2>{{ elmt.title }}</h2>
                <div
                    v-for="(subElmt, index) in elmt.paragraphs"
                    :key="index">
                    <h3 v-if="subElmt.title">
                        {{ subElmt.title }}
                    </h3>
                    <p>
                        {{ subElmt.text }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TopInfos'
}
</script>

<style lang="scss" scoped>
  .container-top {
    background-color: $grey-15;
    color: white;
    padding: 100px 20%;
    @include flex(row, flex-start, center);
    &__left {
      width: 50%;
      min-width: 316px;
      background-color: $gray4;
      padding: 40px;
      margin-right: 40px;
      border-radius: 15px;
      box-shadow: 0px 0px 15px #0000002b;
      div {
        margin: 20px 0px;
        p {
          margin: 0;
        }
      }
    }
    p {
      color: #a0a4a7;
    }
    h2 {
      text-transform: uppercase;
      font-weight: 600;
      font-size: 25px;
      font-weight: bold;
    }
    h3 {
      font-size: 18px;
      text-transform: uppercase;
      font-weight: bold;
      color: white;
    }
    div {
      text-align: left;
      @include flex(column, flex-start, center);
    }
    a {
      color: #a0a4a7;
      transition: 100ms;
      &:hover {
        text-decoration: none;
        color: $blue-2;
      }
    }
    &__right {
        p {
            font-size: 16px;
        }
        h2 {
            font-size: 28px;
            font-weight: bold;
            margin: 20px 0px;
            margin-top: 30px;
        }
        h3 {
            color: #a0a4a7;
            font-weight: bold;
            margin: 10px 0px;
            font-size: 20px;
            span {
                text-transform: none;
                font-weight: normal;
                font-size: 16px;
            }
        }
    }
    &__paragraph {
        &:first-of-type {
            margin-top: -30px;
        }
    }
  }
@media (max-width: 1430px) {
      .container-top {
          padding: 90px 15%;
      }
  }
  @media (max-width: 1120px) {
      .container-top {
          padding: 80px 10%;
          @include flex(column-reverse, flex-start, center);
          &__left {
              margin-top: 50px;
              width: 100%;
              min-width: auto;
          }
      }
  }
</style>
